import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";
import PharmacySetupC1Layout from "../pharmacy-setup/PharmacySetupC1Layout";

const LabInvestigationWorklistPage = Loadable(
  lazy(() => import("./pages/lab/LabInvestigationWorklistPage")),
);
const LabOrderDetailPage = Loadable(lazy(() => import("./pages/lab/LabOrderDetailPage")));
const LabRegistrationExecutionPage = Loadable(
  lazy(() => import("./pages/lab/LabRegistrationExecutionPage")),
);
const LabQueueExecutionDeskPage = Loadable(
  lazy(() => import("./pages/lab/LabQueueExecutionDeskPage")),
);
const LabReportsPage = Loadable(lazy(() => import("./pages/lab/reports/LabReportsPage")));
const LabCounterCollectionPage = Loadable(
  lazy(() => import("./pages/lab/LabCounterCollectionPage")),
);
const PharmacyCounterExecutionPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyCounterExecutionPage")),
);
const PharmacyReturnsExecutionPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyReturnsExecutionPage")),
);
const PharmacyEnterpriseMasterPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyEnterpriseMasterPage")),
);
const PharmacyEnterpriseBulkImportPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyEnterpriseBulkImportPage")),
);
const PharmacyEnterpriseImportReportPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyEnterpriseImportReportPage")),
);
const EnterpriseMedicineCreatePage = Loadable(
  lazy(() => import("./pages/pharmacy/EnterpriseMedicineCreatePage")),
);
const PharmacyHospitalMedicineMappingPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyHospitalMedicineMappingPage")),
);
const PharmacyCategoryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyCategoryPage")),
);
const PharmacyHospitalMedicinePricingPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyHospitalMedicinePricingPage")),
);
const PharmacySetupPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacySetupPage")),
);
const PharmacySetupOverviewPage = Loadable(
  lazy(() => import("../pharmacy-setup/PharmacySetupOverviewPage")),
);
const PharmacySetupDuplicatesPage = Loadable(
  lazy(() => import("../pharmacy-setup/PharmacySetupDuplicatesPage")),
);
const PharmacySetupAiReviewPage = Loadable(
  lazy(() => import("../pharmacy-setup/PharmacySetupAiReviewPage")),
);
const PharmacySupplierPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacySupplierPage")),
);
const PharmacyManufacturerPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyManufacturerPage")),
);
const PharmacyPurchaseOrderPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyPurchaseOrderPage")),
);
const PharmacyGoodsReceiptPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyGoodsReceiptPage")),
);
const PharmacyPurchaseEntryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyPurchaseEntryPage")),
);
const PharmacyPurchaseInvoicePage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyPurchaseInvoicePage")),
);
const PharmacyPurchaseReturnPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyPurchaseReturnPage")),
);
const PharmacyInventoryDashboardPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyInventoryDashboardPage")),
);
const PharmacyCurrentStockPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyCurrentStockPage")),
);
const PharmacyInventoryInquiryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyInventoryInquiryPage")),
);
const PharmacyBatchInventoryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyBatchInventoryPage")),
);
const PharmacyBatchHistoryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyBatchHistoryPage")),
);
const PharmacyStockLedgerPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyStockLedgerPage")),
);
const PharmacyMovementHistoryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyMovementHistoryPage")),
);
const PharmacyStockAdjustmentPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyStockAdjustmentPage")),
);
const PharmacyStockCountPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyStockCountPage")),
);
const PharmacyLowStockPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyLowStockPage")),
);
const PharmacyInventorySettingsPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyInventorySettingsPage")),
);
const PharmacyFefoPreviewPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyFefoPreviewPage")),
);
const PharmacyExpiryDashboardPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyExpiryDashboardPage")),
);
const PharmacyNearExpiryPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyNearExpiryPage")),
);
const PharmacyExpiredStockPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyExpiredStockPage")),
);
const PharmacyExpiryCalendarPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyExpiryCalendarPage")),
);
const PharmacyRecallCenterPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyRecallCenterPage")),
);
const PharmacyNotificationCenterPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyNotificationCenterPage")),
);
const PharmacyReportsPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyReportsPage")),
);
const PharmacyAnalyticsDashboardPage = Loadable(
  lazy(() => import("./pages/pharmacy/PharmacyAnalyticsDashboardPage")),
);

function labQueueDesk(path, deskKey) {
  return {
    path,
    element: (
      <OperationalRouteGuard moduleId="LAB_COUNTER">
        <LabQueueExecutionDeskPage deskKey={deskKey} />
      </OperationalRouteGuard>
    ),
  };
}

/** Phase-1 operational runtime routes — OPS-PHASE1-011 execution parity bridge. */
const OperationalModuleRoutes = [
  {
    path: "/lab/worklist",
    element: (
      <OperationalRouteGuard moduleId="LAB_COUNTER">
        <LabInvestigationWorklistPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/lab/orders/:labOrderNumber",
    element: (
      <OperationalRouteGuard moduleId="LAB_COUNTER">
        <LabOrderDetailPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/lab/counter",
    element: (
      <OperationalRouteGuard moduleId="LAB_COUNTER">
        <LabRegistrationExecutionPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/lab/payments",
    element: (
      <OperationalRouteGuard moduleId="LAB_COUNTER">
        <LabCounterCollectionPage />
      </OperationalRouteGuard>
    ),
  },
  labQueueDesk("/lab/collection", "lab-collection"),
  labQueueDesk("/lab/result-entry", "lab-result-entry"),
  labQueueDesk("/lab/verification", "lab-verification"),
  labQueueDesk("/lab/print-queue", "lab-print-queue"),
  {
    path: "/lab/reports",
    element: <LabReportsPage />,
  },

  /* Radiology routes: see app/views/radiology/RadiologyModuleRoutes.jsx (full shell port). */

  {
    path: "/pharmacy/counter",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_COUNTER">
        <PharmacyCounterExecutionPage />
      </OperationalRouteGuard>
    ),
  },
  /* Dispense / Print Queue aliases — same Counter workspace (Sprint 12B UX). */
  {
    path: "/pharmacy/issue",
    element: <Navigate to="/pharmacy/counter" replace />,
  },
  {
    path: "/pharmacy/dispense",
    element: <Navigate to="/pharmacy/counter" replace />,
  },
  {
    path: "/pharmacy/print-queue",
    element: <Navigate to="/pharmacy/counter" replace />,
  },
  {
    path: "/pharmacy/returns",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_COUNTER">
        <PharmacyReturnsExecutionPage />
      </OperationalRouteGuard>
    ),
  },

  /* Pharmacy Setup workspace — Lab Catalog twin. Existing deep-link paths preserved. */
  {
    element: <PharmacySetupC1Layout />,
    children: [
      {
        path: "/pharmacy/admin/setup",
        element: (
          <OperationalRouteGuard>
            <PharmacySetupOverviewPage />
          </OperationalRouteGuard>
        ),
      },
      {
        // Legacy Setup Console bookmark → Pharmacy Setup Overview
        path: "/setup/pharmacy",
        element: <Navigate to="/pharmacy/admin/setup" replace />,
      },
      {
        path: "/setup/pharmacy/configuration",
        element: <Navigate to="/setup/pharmacy/configuration/generics" replace />,
      },
      {
        path: "/setup/pharmacy/configuration/:section",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_SETUP_GENERICS">
            <PharmacySetupPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacyEnterpriseMasterPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/import",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacyEnterpriseBulkImportPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/import/reports/:executionId",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacyEnterpriseImportReportPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/duplicates",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacySetupDuplicatesPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/ai-review",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacySetupAiReviewPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/new",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <EnterpriseMedicineCreatePage mode="create" />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/:enterpriseMedicineId/edit",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <EnterpriseMedicineCreatePage mode="edit" />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/:enterpriseMedicineId/history",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <EnterpriseMedicineCreatePage mode="history" />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/enterprise/:enterpriseMedicineId",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <EnterpriseMedicineCreatePage mode="view" />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/hospital-mapping",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacyHospitalMedicineMappingPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/categories",
        element: (
          <OperationalRouteGuard
            moduleIds={["PHARMACY_ENTERPRISE_MEDICINES", "PHARMACY_HOSPITAL_INVENTORY_MAPPING"]}
          >
            <PharmacyCategoryPage />
          </OperationalRouteGuard>
        ),
      },
      {
        path: "/pharmacy/admin/hospital-pricing",
        element: (
          <OperationalRouteGuard moduleId="PHARMACY_ENTERPRISE_MEDICINES">
            <PharmacyHospitalMedicinePricingPage />
          </OperationalRouteGuard>
        ),
      },
    ],
  },

  {
    path: "/pharmacy/procure",
    element: <Navigate to="/pharmacy/procure/suppliers" replace />,
  },
  {
    path: "/pharmacy/procure/suppliers",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_PROCURE">
        <PharmacySupplierPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/manufacturers",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_PROCURE">
        <PharmacyManufacturerPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/purchase-orders",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_PROCURE">
        <PharmacyPurchaseOrderPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/grns",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_GRN">
        <PharmacyGoodsReceiptPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/purchase-entry",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_PROCURE">
        <PharmacyPurchaseEntryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/purchase-invoices",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_PROCURE">
        <PharmacyPurchaseInvoicePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/purchase-returns",
    element: (
      <OperationalRouteGuard moduleIds={["PHARMACY_GRN", "PHARMACY_PROCURE"]}>
        <PharmacyPurchaseReturnPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/procure/invoices",
    element: <Navigate to="/pharmacy/procure/purchase-invoices" replace />,
  },

  {
    path: "/pharmacy/inventory",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyInventoryDashboardPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/current-stock",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyCurrentStockPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/inquiry",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyInventoryInquiryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/batches",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyBatchInventoryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/batch-history",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyBatchHistoryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/ledger",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyStockLedgerPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/movements",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyMovementHistoryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/adjustments",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_ADJUST">
        <PharmacyStockAdjustmentPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/counts",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_ADJUST">
        <PharmacyStockCountPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/low-stock",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyLowStockPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/settings",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyInventorySettingsPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/inventory/fefo",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyFefoPreviewPage />
      </OperationalRouteGuard>
    ),
  },

  {
    path: "/pharmacy/expiry",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyExpiryDashboardPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/expiry/near",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyNearExpiryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/expiry/expired",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyExpiredStockPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/expiry/calendar",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyExpiryCalendarPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/expiry/recalls",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyRecallCenterPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/expiry/notifications",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_INVENTORY">
        <PharmacyNotificationCenterPage />
      </OperationalRouteGuard>
    ),
  },

  {
    path: "/pharmacy/reports",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_REPORT">
        <PharmacyReportsPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/pharmacy/reports/analytics",
    element: (
      <OperationalRouteGuard moduleId="PHARMACY_REPORT">
        <PharmacyAnalyticsDashboardPage />
      </OperationalRouteGuard>
    ),
  },

  {
    path: "/clinical/opd-consultation",
    element: (
      <OperationalRouteGuard moduleId="DOCTOR_CONSULTATION">
        <Navigate to="/patients/visits" replace />
      </OperationalRouteGuard>
    ),
  },
];

/** Legacy bookmarks → canonical Phase-1 paths (no duplicate pages). */
export const OperationalAliasRoutes = [
  {
    path: "/healthcare-portal/patient-token",
    element: <Navigate to="/patients/patient-token" replace />,
  },
  {
    path: "/healthcare/patient-token",
    element: <Navigate to="/patients/patient-token" replace />,
  },
  {
    path: "/workspace/patient",
    element: <Navigate to="/billing/patient-journey" replace />,
  },
  {
    path: "/workspaces/reception",
    element: <Navigate to="/patients" replace />,
  },
];

export default OperationalModuleRoutes;
